
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight",attrs:{"d":"M16.004 7.007h-.75c-.276 0-.501.226-.501.5 0 .276.225.501.5.501h.751c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M19.758 3.003h-3.003A3.012 3.012 0 0013.752 0H9.998a3.012 3.012 0 00-3.003 3.003H4.242a2.51 2.51 0 00-2.503 2.503v1c0 .752.576 1.377 1.302 1.477l1.276 13.74A2.505 2.505 0 006.82 24h10.36a2.505 2.505 0 002.503-2.277l1.276-13.74a1.508 1.508 0 001.302-1.476V5.506a2.51 2.51 0 00-2.503-2.503zm-9.76-2.002h3.754c1.101 0 2.002.901 2.002 2.002H7.996c0-1.101.9-2.002 2.002-2.002zM21.26 6.507c0 .275-.226.5-.5.5h-.251c-.25 0-.476.2-.5.45l-1.327 14.19a1.52 1.52 0 01-1.502 1.377H6.82c-.776 0-1.427-.6-1.502-1.377L4.042 8.009H13c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-9.76a.502.502 0 01-.5-.501V5.506c0-.826.675-1.502 1.5-1.502h15.517c.826 0 1.502.676 1.502 1.502v1z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M7.996 10.01c-.275 0-.5.226-.5.5v9.51c0 .276.225.501.5.501s.5-.225.5-.5v-9.51c0-.275-.225-.5-.5-.5z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M12 10.01c-.275 0-.5.226-.5.5v9.51c0 .276.225.501.5.501s.5-.225.5-.5v-9.51c0-.275-.225-.5-.5-.5z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M16.004 10.01c-.275 0-.5.226-.5.5v9.51c0 .276.225.501.5.501s.5-.225.5-.5v-9.51c0-.275-.225-.5-.5-.5z","fill":"#00003C"}})])
          )
        }
      }
    